import { Component, Input, OnInit } from '@angular/core';
import { SiteSettingsApiService } from '../../modules/site-settings/services/api/site-settings-api.service';
import { SettingsMapping } from '../../modules/site-settings/models/site-settings.model';

@Component({
  selector: 'app-maintenance-mode-page',
  templateUrl: './maintenance-mode-page.component.html',
  styleUrls: ['./maintenance-mode-page.component.scss'],
  standalone: false
})
export class MaintenanceModePageComponent implements OnInit {
  maintenanceMessage: string;

  constructor(private readonly siteSettingsApiService: SiteSettingsApiService) {}

  ngOnInit(): void {
    this.fetchMaintenanceMessage();
  }

  fetchMaintenanceMessage() {
    this.siteSettingsApiService.getByShortname(SettingsMapping.maintenanceMessage).subscribe((response) => {
      this.maintenanceMessage = response[0].value;
    });
  }
}
